import { Chip, Stack, Typography } from '@healthinal/ui';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import {
  getGetScreeningTracingIndividualQueryKey,
  getScreeningTracingIndividual,
} from '../../../../../api/created/screening.ts';
import { getScreeningAssessmentStatusColor, getScreeningAssessmentStatusName } from '../../../../../utils/screening.ts';
import { LabOrderResultList } from '../../../../contact-tracing/$patientId/components/lab-order/LabOrderResultList.tsx';
import { ScreeningIndividualPersonalDetailsCard } from '../../components/ScreeningIndividualPersonalDetailsCard.tsx';
import { ScreeningPreventiveTherapyCard } from '../../components/ScreeningPreventiveTherapyCard.tsx';
import { ScreeningTuberculosisHistoryCard } from '../../components/ScreeningTuberculosisHistoryCard.tsx';

export const Route = createFileRoute('/screening/$screeningId/individuals/$individualId/')({
  component: ScreeningIndividualDetails,
  staticData: { title: 'Personalien' },
});

function ScreeningIndividualDetails() {
  const { individualId } = Route.useParams();
  const { data: individual } = useSuspenseQuery({
    queryKey: getGetScreeningTracingIndividualQueryKey(individualId),
    queryFn: ({ signal }) => getScreeningTracingIndividual(individualId, undefined, signal),
  });

  return (
    <>
      <Stack direction="row" gap={1} pb={2} flexWrap="wrap">
        {individual.assessmentStatus && (
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography fontWeight="bold">Screening Status:</Typography>
            <Chip
              color={getScreeningAssessmentStatusColor(individual.assessmentStatus)}
              variant="solid"
              sx={{ fontWeight: 'bold' }}>
              {getScreeningAssessmentStatusName(individual.assessmentStatus)}
            </Chip>
          </Stack>
        )}
        {individual.assessmentNotes && <Typography>{individual.assessmentNotes}</Typography>}
      </Stack>
      <Stack direction="row" gap={2}>
        <Stack flex={1} gap={2}>
          <ScreeningIndividualPersonalDetailsCard individual={individual} />
        </Stack>
        <Stack flex={1} gap={2}>
          <ScreeningTuberculosisHistoryCard individualId={individualId} />
          <LabOrderResultList patientId={individualId} />
          <ScreeningPreventiveTherapyCard individualId={individualId} />
        </Stack>
      </Stack>
    </>
  );
}
